<template>
  <academy-form
    v-if="academy"
    action="update"
    :loading="loading"
    :updating="updating"
    :data="academy"
    :error-messages="errorMessages"
    :handle-submit="handleFormSubmit"
    :handle-discard="handleDiscard"
  />
</template>

<script>
// eslint-disable-next-line object-curly-newline, no-unused-vars
import { onUnmounted, ref, computed, provide, getCurrentInstance } from '@vue/composition-api'

import { useRouter } from '@core/utils'
import useAcademyView from './useAcademyView'

import AcademyForm from './academy-form/AcademyForm.vue'

export default {
  components: {
    AcademyForm,
  },
  setup() {
    const vm = getCurrentInstance().proxy
    const { route } = useRouter()

    const {
      academy,
      loading,
      updating,

      errorMessages,

      init,
      destroy,

      updateData,
    } = useAcademyView(route.value.params.id)

    // Init
    init()

    // Destroy
    onUnmounted(() => {
      destroy()
    })

    // const academyDataLocal = computed(() => academy.value)

    const handleFormSubmit = formData => updateData(formData)
    const handleDiscard = () => vm.$router.replace({ name: 'academy-view', params: { id: route.value.params.id } })

    return {
      academy,
      loading,
      updating,
      updateData,

      errorMessages,

      // academyDataLocal,

      handleFormSubmit,
      handleDiscard,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
